import { inject } from '../../../../../common/container/inject';
import { ILearningRootService, LearningRootServiceToken } from '../../../../../service/LearningRootService';
import { IProjectLearningReportArg } from '../../../../../service/report/interface/IProjectLearningReportArg';
import { IMetricsDomain } from './IMetricsDomain';

export class MetricsDomain implements IMetricsDomain {
  constructor(
    protected learningRootService = inject<ILearningRootService>(LearningRootServiceToken),
  ) {}

  getMetricsData = (arg: IProjectLearningReportArg = {}) => this.learningRootService.report.getMetrics(arg);
}
